module.exports = "<ng-container #messageContainer></ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/dynamic-message/dynamic-message.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/dynamic-message/dynamic-message.component.html
// module chunks = 0